export default "__VITE_ASSET__DEAhMSG6__"